import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

export const basketService = {
  /**
   * Kullanıcının seyahatlerini getirir
   * @param {Object} payload - Request payload
   * @param {string} [payload.productType] - Ürün tipi: "Flight", "Bus", "Hotel", "Ferry", "Car" (opsiyonel, null ise tüm ürün tipleri)
   * @param {string} [payload.filterType] - Filtre tipi: "Upcoming", "Past", "Refunded", "Reissued", "Reservation" (opsiyonel, null ise tüm triplar)
   * @param {number} [payload.pageNumber] - Sayfa numarası (default: 1)
   * @param {number} [payload.pageSize] - Sayfa boyutu (default: 10, max: 50)
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   */
  getMyTrips: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.basket.getMyTrips,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * PNR numarası ile basket hash code oluşturur
   * @param {Object} payload - Request payload
   * @param {string} payload.ProductType - Ürün tipi: "Flight", "Bus", "Hotel", "Ferry", "Car"
   * @param {string} payload.PnrNo - PNR numarası
   * @param {string} payload.LastName - Soyadı
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   */
  generateBasketHashCodeByPnr: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.basket.generateBasketHashCode,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Ticket numarası ile basket hash code oluşturur
   * @param {Object} payload - Request payload
   * @param {string} payload.ProductType - Ürün tipi: "Flight", "Bus", "Hotel", "Ferry", "Car"
   * @param {string} payload.TicketNo - Ticket numarası
   * @param {string} payload.LastName - Soyadı
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   */
  generateBasketHashCodeByTicket: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.basket.generateBasketHashCode,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Hash code ile basket bilgilerini getirir
   * @param {Object} payload - Request payload
   * @param {string} payload.Code - Hash code
   * @param {string} payload.Currency - Para birimi (örn: "TRY", "USD")
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   */
  getBasketByHashCode: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.basket.getBasketByHashCode,
      payload,
      headers,
      hasErrorHandler,
    }),
};
